import { render, staticRenderFns } from "./DataVersionRecord.vue?vue&type=template&id=c3da2c4a&scoped=true"
import script from "./DataVersionRecord.vue?vue&type=script&lang=js"
export * from "./DataVersionRecord.vue?vue&type=script&lang=js"
import style0 from "./DataVersionRecord.vue?vue&type=style&index=0&id=c3da2c4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3da2c4a",
  null
  
)

export default component.exports